import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { SettingsService } from '@app/services/settings/settings.service';
import { SharedModule } from '@app/shared/shared.module';
import { environment } from '@environments/environment';
import { ParallaxStandaloneDirective } from '@yoozly/ngx-parallax';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [
		SharedModule,
		ParallaxStandaloneDirective,
	],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss'
})
export class HeroComponent implements OnInit {
	public loading: boolean = false;
	public titleImg:boolean = true;
	public title: string = environment.title;
	public subtitle?: string;
	public subscriptionOpen: boolean = false;

	constructor (
		public nav: NavigationService,
		private settings: SettingsService,
	) { }

	ngOnInit(): void {
		this.load();
	}

	private async load() {
		this.loading = true;
		const year = await this.settings.getSubscriptionYear();
		const isOpen = await this.settings.isOpen();
		if(isOpen) this.subOpen(year);
		this.loading = false;
	}

	private subOpen(year:number|string): void {
		this.subscriptionOpen = true;
		this.subtitle = `Cadastros Abertos Para ${year}`;
	}




}
